<template>
  <!-- 我的积分 -->
  <div>
    <el-row>
      <el-col :span="17" style="padding-top: 25px">
        <div class="redPack_right">
          <div class="my-title">我的会员等级</div>
           <div class="huiy">

               <div class="huit" v-for="item in tableData" :key="item.grade">
                  <img v-if="vip_Grade==item.grade" :src="tableData[vip_Grade-1].icon" alt="">
                   <span  v-if="vip_Grade==item.grade">我的等级:{{tableData[vip_Grade-1].title}}</span>
               </div>
           </div>
          <div style="width:500px;margin:40px auto">
            <el-steps :space="200" :active="vip_Grade-1" finish-status="success">
             <el-step  v-for="item in tableData" :key="item.grade" :title="item.title"></el-step>
            </el-steps>

          </div>
          <div class="my-title">会员权益</div>

          <!-- 表格  -->
          <div class="draftsTable">
            <el-table
              :data="tableDataList"
              :header-cell-style="{
                color: '#848484',
                background: '#f4f4f4',
                textAlign: 'center',
              }"
              border
              style="width: 100%"
              :cell-style="{ textAlign: 'center' }"
            >

              <el-table-column prop="title" label="对应等级" width="180">
              </el-table-column>
              <el-table-column prop="description" label="对应等级"></el-table-column>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="shopp_pagination">
            <el-button
              size="small"
              style="width: 80px; height: 30px"
              @click="pervious"
              >上一页</el-button
            >
            <el-pagination
              ref="pageGroup"
              :current-page="currentPage"
              :page-size="pageSize"
              @current-change="handleCurrentChange"
              background
              layout="pager"
              :total="total"
            >
            </el-pagination>
            <el-button
              style="width: 80px; height: 30px"
              size="small"
              @click="next"
              >下一页</el-button
            >
          </div>
        </div>
      </el-col>
      <el-col :span="1">
        <div class="redPack_con"></div>
      </el-col>
      <el-col :span="6" style="padding-top: 25px">
        <div class="redPack_left">
          <div class="my-title">什么是会员等级?</div>
          <div class="red_rule">
          {{viptRule}}
          </div>
          <div class="my-title">会员如何实现分级?</div>
          <div class="red_rule">
          {{viptRule2}}
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
if (localStorage.getItem("userInfo")) {
  var token = JSON.parse(localStorage.getItem("userInfo")).token;
  var header = {
    "Content-Type": "application/json",
    token: token,
    platform: "H5",
  };
}
import { shoproUser, getUserIndex,indexRule } from "@/api/index.js";

export default {
  data() {
    return {
      tableData: [],
      score: "",
      total: 1,
      currentPage: 1,
      pageSize: 4,
      reverse: true,
      activities: [],
      vip_Grade:'',
      viptRule:'',
      viptRule2:''

    };
  },

  created() {
    this.getUser();
    this.getIntegral();
    this.getIndexRule();
  },

  methods: {
      //会员规则
    getIndexRule(){
        indexRule({}).then(res=>{
            console.log(res);
            if(res.code !==1){
                return
            }
            this.viptRule = res.data.vipGrade
            this.viptRule2 = res.data.vipGrade2

        })
    },
    //获取个人信息
    getUser() {
      shoproUser({}, header).then((res) => {
        if (res.code !== 1) {
          return;
        }
        this.score = res.data.score;
      });
    },
    //会员明细
    getIntegral() {
      getUserIndex({}, header).then((res) => {
        console.log(res);
        if (res.code !== 1) {
          return;
        }
        this.tableData = res.data.vipInfo;
        this.vip_Grade = res.data.vipGrade
        this.total = res.data.vipInfo.length;

      });
    },
    dateFormat(row, column) {
      let date = row[column.property];
      //console.log(moment);
      if (date == undefined) {
        return "";
      }
      return this.moment(date * 1000).format("YYYY.MM.DD");
    },
    //上一页
    pervious() {
      this.$refs.pageGroup.prev();
    },
    //下一页
    next() {
      this.$refs.pageGroup.next();
    },
    handleCurrentChange(newNum) {
      this.currentPage = newNum;
    },
  },
  computed: {
    tableDataList: function () {
      return this.tableData.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
  },
};
</script>
<style lang="less" scoped>
.huit{
    display: flex;
    flex-direction: column;
    color: #CA8700;
    span{
        margin-top: 10px;
    }
}
.huiy{
        display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    margin: 40px 0;
}
.el-step.is-horizontal{
    flex-basis: 100px !important;
}
.sidebar {
  margin: 0 auto;
  width: 500px;
  text-align: center;
}


.bg-div {
  border-top: 1px dashed #d0d0d0;
  margin-top: 26px;
  left: 140px;

  position: absolute;
  z-index: 1;
}

.sidebar ul {
  position: relative;
  z-index: 10;
  height: 100px;
  display: block;
}


.sidebar li {
  font-size: 14px;
  line-height: 50px;
  list-style-type: none;
  float: left;

  width: 100px;
  position: relative;
}



.inner {
  display: block;
  height: 9px;
  width: 9px;
  background: #dddddd;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
.inners{
      display: block;
  height: 9px;
  width: 9px;
  background:#ff6701;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

.sidebar .point {
  vertical-align: middle;
  background: #fff;
  display: inline-block;
  padding: 4px;
  height: 9px;
  width: 9px;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}

.txt_class {
  position: absolute;
  width: 100%;
  left: 0;
  top: 20px;

  font-size: 12px;
  cursor: pointer;
}
.shopp_pagination {
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
.my-title {
  // height: 40px;
  font-size: 20px;
  padding: 0 10px;
  border-left: 5px solid #ff6701;
  margin-bottom: 10px;
  margin-left: 32px;
  line-height: 40px;
}

.redPack_con {
  background: color(#f5f5f5);
  height: 622px;
}

.el-col-17 {
  border: 1px solid #0097fe;
//   height: 730px;
}
.el-col-6 {
  border: 1px solid #0097fe;
  height: 622px;
}

.red_rule {
  width: 207px;
  //   height: 398px;
  font-size: 12px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #666666;
  line-height: 25px;
  margin: 0 auto;
}
.my_h{
     border-top: 1px dashed #FF6701;

 margin-top: 26px;
  left: 140px;

  position: absolute;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/myVip.vue